<template>
  <div class="p-12 min-h-screen">
    <div class="max-w-lg w-full mx-auto space-y-8">
      <BaseCard v-if="successMessage">
        <div class="px-10 py-10 space-y-8 text-center">
          <div class="bg-green-50 rounded-lg p-4 inline-block">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="text-green-600 w-10 h-10"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z" />
            </svg>
          </div>
          <BaseHeading :level="2" class="text-center font-bold">
            Password reset succesfully
          </BaseHeading>

          <p v-if="successMessage" class="text-gray-600 text-center">
            {{ successMessage }}
          </p>
        </div>
        <div class="px-12 py-10 text-center bg-gray-50">
          <RouterLink
            v-slot="{ href, navigate }"
            :to="{
              name: 'login',
              replace: true,
            }"
            custom
          >
            <BaseButton primary tag="a" :href="href" class="w-full" @click="navigate">
              Login
            </BaseButton>
          </RouterLink>
        </div>
      </BaseCard>

      <PasswordResetForm v-else @success="notifyPasswordResetSuccess" />
    </div>
  </div>
</template>

<script>
import PasswordResetForm from '@/forms/PasswordResetForm.vue';

export default {
  name: 'ResetPasswordView',
  components: { PasswordResetForm },
  data() {
    return {
      successMessage: '',
    };
  },
  methods: {
    notifyPasswordResetSuccess(response) {
      this.successMessage = response.data?.message || '';
    },
  },
};
</script>
